import * as moment from "moment";

export const isObligedAnswerQP = (form: any): boolean => {
    if(
        form &&
        form.sections[0].questions[0].answers.length === 0 &&
        form.sections[0].questions[7].answers.length === 0 &&
        form.sections[0].questions[16].answers.length === 0
      ){
      return true
    } else {
      return false
    }
  };
export const isObligedAnswerQPV2 = (form: any): boolean => {
    if(
        form &&
        form.sections[0].questions[1].answers.length === 0 &&
        form.sections[0].questions[6].answers.length === 0 &&
        form.sections[0].questions[15].answers.length === 0
      ){
      return true
    } else {
      return false
    }
  };
  

  export const canModifiedQP = (context: any, enterprise: any, user: any): boolean => {
    if(moment().isAfter(moment(enterprise.qp_last_updated_at), "day")) {
      return true
    } else {
      if (enterprise.qp_daily_update >= 2) return false
    }
    if(
        (context && 
         context.can_edit_qp_without_topaze === false && 
         user && 
         user.topaze_id === undefined && 
         enterprise && 
         enterprise.is_pro === false ) 
       || 
        (context && 
          context.can_edit_qp_without_topaze === false && 
          user && 
          user.topaze_id !== undefined && 
          user.topaze_id.length === 0 &&
          enterprise && 
          enterprise.is_pro === false ) 
       ||
         (context && 
          context.can_edit_qp_without_topaze === false && 
          user && 
          user.topaze_id !== undefined && 
          enterprise && 
          enterprise.is_pro === false &&
          enterprise.qp_status === 'pending' ) 
        ||
         (enterprise && 
          enterprise.qp_status === 'pending' && 
          enterprise.is_pro === false)
       ||
         (enterprise && 
          enterprise.is_pro === true)
      ){
      return false
    } else {
      return true
    }
  };
  
  export const isBtnEditActived = (context: any, enterprise: any, user: any): boolean => {
    if(
        enterprise && 
        (enterprise.habilitations === undefined || enterprise.habilitations.length === 0 || enterprise.habilitations === null) && 
        enterprise.is_mandataire === false
      ){
      return false;
    } else {
      return canModifiedQP(context, enterprise, user);
    }
  }


// WEBPACK FOOTER //
// ./src/shared/FormArkea/helpers.tsx